import Matter from 'matter-js';


export const Physics = (entities, parms) => {
    //console.log({ entities, parms });
    Matter.Engine.update(entities.physics.engine, parms.time.delta);
    return entities;
};
